// 2026-09-29：全局管理端声音服务，登录后检查增量通知，设置按机构和账号隔离。
import { reactive } from 'vue'
import request from '@/utils/request'
import { createChimePlayer, createNotificationSound, createSoundDelivery, SoundPage, SoundState } from './notificationSound'

export const notificationSoundState = reactive<SoundState>({ enabled: true, volume: 35, ready: false, supported: true })
const AudioConstructor = window.AudioContext || (window as any).webkitAudioContext
const player = createChimePlayer(() => AudioConstructor ? new AudioConstructor() : null, ready => { notificationSoundState.ready = ready })
player.available = () => Boolean(AudioConstructor)
const storage = {
  getItem: (key: string) => window.localStorage.getItem(key),
  setItem: (key: string, value: string) => window.localStorage.setItem(key, value)
}
const deliver = createSoundDelivery(storage, async (name, action) => {
  const locks = (navigator as Navigator & { locks?: { request: (key: string, callback: () => void) => Promise<void> } }).locks
  if (locks) {
    let entered = false
    try { await locks.request(name, () => { entered = true; action() }); return }
    catch (_) { if (entered) return }
  }
  // 无锁或锁不可用时由可见页面提示，保留共享水位去重；后台标签不抢占声音。
  if (document.visibilityState === 'visible') action()
})
export const notificationSound = createNotificationSound({
  state: notificationSoundState,
  storage, deliver,
  player,
  fetch: async afterId => {
    const result: any = await request({ url: 'order/notificationSounds', method: 'GET', params: { afterId, limit: 200 } })
    return result.data as SoundPage
  },
  schedule: (callback, delay) => window.setTimeout(callback, delay),
  cancel: id => window.clearTimeout(id)
})
